// Gecici ornek veri — Forms modulu (Request Forms / Fields / Ticket Types).
// Backend servisleri gelince ilgili get* cagrilariyla degistirilir; simdilik mock.

export interface RequestForm {
    ref: number;
    name: string;
    description: string;
    fieldCount: number;
    channel: string;
    isActive: boolean;
}

export interface FormField {
    ref: number;
    label: string;
    key: string;
    // Alan tipi: text | textarea | number | dropdown | date | checkbox | file
    type: string;
    required: boolean;
    isActive: boolean;
}

export interface TicketType {
    ref: number;
    name: string;
    code: string;
    slaHours: number;
    color: string;
    isActive: boolean;
}

export const MOCK_REQUEST_FORMS: RequestForm[] = [
    { ref: 1, name: "Genel Destek Talebi", description: "Standart müşteri destek talebi formu", fieldCount: 5, channel: "Portal", isActive: true },
    { ref: 2, name: "Teknik Arıza Bildirimi", description: "Yazılım/donanım arıza kaydı", fieldCount: 7, channel: "Portal", isActive: true },
    { ref: 3, name: "İade Talebi", description: "Ürün iade ve değişim formu", fieldCount: 6, channel: "E-posta", isActive: true },
    { ref: 4, name: "Bilgi Talebi", description: "Genel bilgi ve fiyat sorgusu", fieldCount: 3, channel: "Widget", isActive: true },
    { ref: 5, name: "Şikayet Formu", description: "Müşteri şikayet kaydı", fieldCount: 4, channel: "Portal", isActive: false },
];

export const MOCK_FORM_FIELDS: FormField[] = [
    { ref: 1, label: "Sipariş No", key: "order_no", type: "text", required: true, isActive: true },
    { ref: 2, label: "Ürün Kategorisi", key: "product_category", type: "dropdown", required: true, isActive: true },
    { ref: 3, label: "Öncelik", key: "priority", type: "dropdown", required: false, isActive: true },
    { ref: 4, label: "Açıklama", key: "description", type: "textarea", required: true, isActive: true },
    { ref: 5, label: "Ek Dosya", key: "attachment", type: "file", required: false, isActive: true },
    { ref: 6, label: "Teslim Tarihi", key: "delivery_date", type: "date", required: false, isActive: true },
    { ref: 7, label: "KVKK Onayı", key: "gdpr_consent", type: "checkbox", required: true, isActive: false },
];

export const MOCK_TICKET_TYPES: TicketType[] = [
    { ref: 1, name: "Destek", code: "SUP", slaHours: 24, color: "#6366F1", isActive: true },
    { ref: 2, name: "Hata", code: "BUG", slaHours: 8, color: "#EF4444", isActive: true },
    { ref: 3, name: "Özellik Talebi", code: "FEAT", slaHours: 72, color: "#10B981", isActive: true },
    { ref: 4, name: "Servis", code: "SRV", slaHours: 48, color: "#F97316", isActive: true },
];
